import { render, staticRenderFns } from "./settingthreshold.vue?vue&type=template&id=2b519560&scoped=true"
import script from "./settingthreshold.vue?vue&type=script&lang=js"
export * from "./settingthreshold.vue?vue&type=script&lang=js"
import style0 from "./settingthreshold.vue?vue&type=style&index=0&id=2b519560&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b519560",
  null
  
)

export default component.exports